export default __webpack_public_path__ + "static/media/icon_pst_tier_platinum.312bf1d5.svg";